/**
 * Live "who is working on / viewing this row" avatar bubbles.
 */

import { Avatar, Tooltip } from '@mantine/core';
import { useResolvedImageUrl } from '@/hooks/useResolvedImageUrl';
import type { PresenceActor } from '@/lib/presence/presenceFhir';

const MAX_VISIBLE = 3;

function PresenceAvatar({ actor }: { actor: PresenceActor }): JSX.Element {
  const src = useResolvedImageUrl(actor.photoUrl);
  return (
    <Tooltip label={actor.name} withArrow>
      <Avatar size="sm" radius="xl" color="gold" src={src}>
        {actor.initials}
      </Avatar>
    </Tooltip>
  );
}

export interface PresenceAvatarsProps {
  actors: PresenceActor[];
}

export function PresenceAvatars({ actors }: PresenceAvatarsProps): JSX.Element | null {
  if (actors.length === 0) return null;

  const visible = actors.slice(0, MAX_VISIBLE);
  const overflow = actors.slice(MAX_VISIBLE);

  return (
    <Avatar.Group>
      {visible.map((actor) => (
        <PresenceAvatar key={actor.actorId} actor={actor} />
      ))}
      {overflow.length > 0 && (
        <Tooltip label={overflow.map((a) => a.name).join(', ')} withArrow>
          <Avatar size="sm" radius="xl" color="gray">
            +{overflow.length}
          </Avatar>
        </Tooltip>
      )}
    </Avatar.Group>
  );
}
